import { c as component } from './bundle_chunk_svelte-tag_29c9b6b9.js';

/**
 * __webpack_public_path__ is a runtime variable passed to webpack
 * Keep this on top of this file
 */

import('./bundle_chunk_lazysizes_da31cfc6.js').then(function (n) { return n.l; });
import('./bundle_chunk_Details_1a25045a.js').then(_ref => {
  var {
    default: Details
  } = _ref;
  new component({
    component: Details,
    tagname: 'sv-details'
  });
});
import('./bundle_chunk_DrawerTrigger_fa8776df.js').then(_ref2 => {
  var {
    default: DrawerTrigger
  } = _ref2;
  new component({
    component: DrawerTrigger,
    tagname: 'sv-drawer-trigger'
  });
});
import('./bundle_chunk_NewsletterForm_77c7c3ab.js').then(_ref3 => {
  var {
    default: NewsletterForm
  } = _ref3;
  new component({
    component: NewsletterForm,
    tagname: 'newsletter-form'
  });
});
import('./bundle_chunk_DrawerMiniCart_61fd67f0.js').then(_ref4 => {
  var {
    default: DrawerMiniCart
  } = _ref4;
  new component({
    component: DrawerMiniCart,
    tagname: 'sv-drawer-minicart'
  });
});
import('./bundle_chunk_SvCarousel_e3262256.js').then(_ref5 => {
  var {
    default: SvCarousel
  } = _ref5;
  new component({
    component: SvCarousel,
    tagname: 'sv-carousel'
  });
});
import('./bundle_chunk_AddToCartButton_e6e929ef.js').then(_ref6 => {
  var {
    default: AddToCartButton
  } = _ref6;
  new component({
    component: AddToCartButton,
    tagname: 'sv-add-to-cart-button'
  });
});
/**
 * Import DrawerHandler, then initialize all drawers
 */

import('./bundle_chunk_DrawerHandler_7165a79e.js').then(_ref7 => {
  var {
    DrawerHandler
  } = _ref7;
  new DrawerHandler({
    drawerName: 'mobile-menu',
    drawerSelector: '.js-mobile-menu',
    triggerSelector: '.js-mobile-menu__toggle',
    overlaySelector: '.js-mobile-menu__overlay',
    panelSelector: '.js-mobile-menu__panel'
  });
  new DrawerHandler({
    drawerName: 'header-search',
    drawerSelector: '.js-header-search-bar',
    triggerSelector: '.js-header-search-bar__toggle',
    panelSelector: '.js-header-search-bar__panel'
  });
});
